import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function LoadingOverlay({
  message,
  subMessage,
}: {
  message: string;
  subMessage?: string;
}) {
  const { t } = useTranslation();
  const [tipIndex, setTipIndex] = useState(0);

  // Didaktik-Tipps als i18n-Array (returnObjects liefert string[] aus den Locales)
  const tips = t("loading.tips", { returnObjects: true }) as string[];

  useEffect(() => {
    const interval = setInterval(() => {
      setTipIndex((prev) => (prev + 1) % tips.length);
    }, 4500);
    return () => clearInterval(interval);
  }, [tips.length]);

  return (
    <div className="fixed inset-0 bg-ca-bg/95 backdrop-blur-xl z-[100] flex flex-col items-center justify-center animate-fade-in">
      <div className="w-24 h-24 relative mb-8">
        <div className="absolute inset-0 border-4 border-ca-border/10 rounded-full" />
        <div className="absolute inset-0 border-4 border-ca-accent border-t-transparent rounded-full animate-spin" />
      </div>
      <p className="text-ca-accent-text font-black text-2xl tracking-tighter mb-2 animate-pulse uppercase">
        {message}
      </p>
      {subMessage && (
        <p className="text-ca-ink-muted text-xs uppercase tracking-[0.25em] font-bold mb-6">
          {subMessage}
        </p>
      )}
      <div className="max-w-md text-center px-6 mt-2">
        <p
          key={tipIndex}
          className="text-ca-ink-muted text-sm italic transition-all duration-500 animate-fade-in leading-relaxed"
        >
          „{tips[tipIndex]}"
        </p>
      </div>
    </div>
  );
}
